/* =========================================================
   Northern Raised · Back to School landing page engine
   Loaded once per page. Safe to include from several sections:
   the guard below makes duplicate script tags a no-op.
   Talks to the Crave (Dawn-family) cart drawer via the
   Section Rendering API, exactly like the theme's own
   product forms do, so adds open the drawer with no reload.
   ========================================================= */
(function () {
  'use strict';
  if (window.NRBTS && window.NRBTS.__loaded) return;
  var NRBTS = (window.NRBTS = window.NRBTS || {});
  NRBTS.__loaded = true;
  NRBTS.products = NRBTS.products || {};
  NRBTS.farms = NRBTS.farms || {};
  NRBTS.config = NRBTS.config || {};

  var html = document.documentElement;
  html.classList.add('nrb-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window;

  /* ---------- utils ---------- */
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function smooth01(x) { x = clamp01(x); return x * x * (3 - 2 * x); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function stars() { return '★★★★★'; }

  /* Shopify money formatting from shop.money_format */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var formatString = format || NRBTS.config.moneyFormat || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function delim(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var value = '';
    var match = formatString.match(placeholderRegex);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = delim(cents, 2); break;
      case 'amount_no_decimals': value = delim(cents, 0); break;
      case 'amount_with_comma_separator': value = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delim(cents, 2, "'", '.'); break;
      default: value = delim(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }
  NRBTS.formatMoney = formatMoney;
  function money(cents) { return formatMoney(Math.round(cents)); }
  function withCode(cents) {
    var pct = parseFloat(NRBTS.config.pct);
    if (!pct) pct = 0;
    return Math.round(cents * (100 - pct) / 100);
  }

  /* ---------- default microcopy (overridable from the theme editor) ---------- */
  var DEFAULT_T = {
    addToCart: 'Add to cart',
    added: 'Added to cart ✓',
    addedShort: 'Added',
    adding: 'Adding…',
    soldOut: 'Sold out',
    youSave: 'You save',
    withCodeAtCheckout: 'with {code} at checkout',
    copyCode: 'Copy code',
    copied: 'Copied',
    optionLabel: 'Choose your option',
    perDinner: 'per family dinner',
    dinnersABox: 'dinners a box',
    about: 'about',
    note1: 'Free delivery available in most regions',
    note2: 'Cut fresh to order',
    orderNext: 'Order in the next',
    earliest: 'for the earliest delivery day',
    routeMid: 'Cut fresh',
    routeEnd: 'Your door',
    deliveryFine: "Delivery days vary by area. You'll pick your exact date at checkout.",
    promiseHtml: '<b>The Northern Raised promise.</b> Everything in your box is cut fresh to order, vacuum-sealed, and inspected before it ships. If anything arrives less than perfect, tell us within 24 hours and a real person will sort it out with you, usually the same day.',
    boxTitle: "What's in the box",
    boxFallback: 'See the product page for full contents.',
    nutritionTitle: 'Nutrition',
    nutritionNote: 'Values shown for raw product. Source: USDA FoodData Central.',
    nutritionFallback: 'Nutrition information is printed on every pack label.',
    shippingTitle: 'Shipping &amp; delivery',
    shippingHtml: '',
    reviewsEyebrow: 'From Ontario kitchens',
    reviewsLabel: 'verified reviews',
    reviewsFallbackLabel: 'Verified reviews',
    viaLoox: 'via Loox',
    verifiedBuyer: '✓ Verified buyer',
    readAll: 'Read all reviews on the product page ↗',
    collectedBy: 'Collected by Loox from verified purchases',
    storeNote: 'Store reviews shown',
    fullPage: 'View the full product page ↗',
    photoTab: 'Photo',
    farmTab: 'The farm',
    boxTab: 'In the box',
    promiseTab: 'Promise',
    promiseSlideEyebrow: 'The Northern Raised promise',
    promiseSlideTitle: 'Cut fresh, sealed, inspected, guaranteed.',
    boxSlideEyebrow: "What's in the box",
    raisedAt: 'Raised at',
    traceIt: 'Trace it',
    readStory: 'Read their story ↗',
    since: 'Since',
    quickView: 'Quick view',
    close: 'Close',
    decrease: 'Decrease quantity',
    increase: 'Increase quantity',
    cartError: 'Could not add to cart. Please try again.',
    addedToast: 'Added to cart · {price} with code',
    perLb: '/lb'
  };
  function T(k) {
    var t = NRBTS.config.t || {};
    var v = t[k];
    return v == null || v === '' ? (DEFAULT_T[k] == null ? '' : DEFAULT_T[k]) : v;
  }

  /* ---------- registrations (JSON script tags rendered by the sections) ---------- */
  function ingest() {
    each(document.querySelectorAll('script[data-nrb-register]'), function (node) {
      if (node.__nrbDone) return;
      node.__nrbDone = true;
      var kind = node.getAttribute('data-nrb-register');
      var data;
      try { data = JSON.parse(node.textContent); } catch (e) { return; }
      if (kind === 'product' && data && data.id) {
        var existing = NRBTS.products[data.id];
        /* fuller registrations (with variants) win over minimal ones */
        if (!existing || (data.variants && data.variants.length)) NRBTS.products[data.id] = data;
      } else if (kind === 'farm' && data && data.name) {
        NRBTS.farms[normName(data.name)] = data;
      } else if (kind === 'config' && data) {
        for (var k in data) {
          if (k === 't') {
            NRBTS.config.t = NRBTS.config.t || {};
            for (var tk in data.t) { if (data.t[tk] !== '' && data.t[tk] != null) NRBTS.config.t[tk] = data.t[tk]; }
          } else if (data[k] !== '' && data[k] != null) NRBTS.config[k] = data[k];
        }
      }
    });
  }
  function normName(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function getProduct(id) { return NRBTS.products[id] || null; }
  function farmFor(p) {
    if (!p || !p.farm || !p.farm.name) return null;
    var reg = NRBTS.farms[normName(p.farm.name)] || {};
    return {
      name: p.farm.name,
      place: p.farm.loc || reg.place || '',
      url: p.farm.url || reg.url || '',
      since: reg.since || '',
      blurb: reg.blurb || '',
      photo: reg.photo || '',
      badge: reg.badge || '',
      tags: reg.tags || []
    };
  }

  /* ---------- chalk + dust canvases (created on demand) ---------- */
  var Chalk = (function () {
    var cv, cx, dv, dc, made = false;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0, dust = [], lastStroke = 0, fadeBoost = 0, raf = null, lt = 0;
    function make() {
      if (made) return true;
      if (!document.querySelector('.nrbts')) return false;
      cv = document.createElement('canvas'); cv.id = 'nrbChalkLayer'; cv.setAttribute('aria-hidden', 'true');
      dv = document.createElement('canvas'); dv.id = 'nrbDustLayer'; dv.setAttribute('aria-hidden', 'true');
      document.body.appendChild(cv); document.body.appendChild(dv);
      cx = cv.getContext('2d'); dc = dv.getContext('2d');
      made = true; size(); window.addEventListener('resize', size);
      return true;
    }
    function size() {
      if (!made) return;
      W = window.innerWidth; H = window.innerHeight;
      [cv, dv].forEach(function (c) { c.width = Math.round(W * dpr); c.height = Math.round(H * dpr); c.style.width = W + 'px'; c.style.height = H + 'px'; });
      cx.setTransform(dpr, 0, 0, dpr, 0, 0); dc.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function kick() { if (made && !raf) raf = requestAnimationFrame(loop); }
    function loop(now) {
      raf = null; var dt = lt ? Math.min(3, (now - lt) / 16.7) : 1; lt = now;
      if (now - lastStroke < 6000 || fadeBoost > 0.01) {
        cx.globalCompositeOperation = 'destination-out';
        cx.fillStyle = 'rgba(0,0,0,' + Math.min(1, (0.024 + fadeBoost) * dt).toFixed(3) + ')';
        cx.fillRect(0, 0, W, H); cx.globalCompositeOperation = 'source-over';
      }
      fadeBoost *= Math.pow(0.88, dt);
      dc.clearRect(0, 0, W, H);
      for (var i = dust.length - 1; i >= 0; i--) {
        var d = dust[i]; d.x += d.vx * dt; d.y += d.vy * dt; d.vy += 0.045 * dt; d.vx *= Math.pow(0.96, dt); d.life -= 0.026 * dt;
        if (d.life <= 0) { dust.splice(i, 1); continue; }
        dc.fillStyle = 'rgba(250,246,239,' + (d.life * 0.8).toFixed(3) + ')';
        dc.beginPath(); dc.arc(d.x, d.y, d.size, 0, 6.283); dc.fill();
      }
      if (dust.length || now - lastStroke < 6000 || fadeBoost > 0.01) raf = requestAnimationFrame(loop);
    }
    return {
      ensure: make,
      stroke: function (x0, y0, x1, y1) {
        if (!make()) return;
        lastStroke = performance.now(); cx.globalCompositeOperation = 'source-over'; cx.lineCap = 'round';
        for (var k = 0; k < 3; k++) {
          cx.strokeStyle = 'rgba(250,246,239,' + (0.16 + Math.random() * 0.22).toFixed(3) + ')';
          cx.lineWidth = 1.1 + Math.random() * 2;
          cx.beginPath();
          cx.moveTo(x0 + (Math.random() - 0.5) * 2.6, y0 + (Math.random() - 0.5) * 2.6);
          cx.lineTo(x1 + (Math.random() - 0.5) * 2.6, y1 + (Math.random() - 0.5) * 2.6);
          cx.stroke();
        }
        kick();
      },
      dust: function (x, y, n, spread) {
        if (!make()) return;
        for (var i = 0; i < n; i++) dust.push({ x: x + (Math.random() - 0.5) * (spread || 8), y: y + (Math.random() - 0.5) * 4, vx: (Math.random() - 0.5) * 1.4, vy: -Math.random() * 1.1 - 0.2, life: 0.7 + Math.random() * 0.5, size: 0.5 + Math.random() * 1.1 });
        if (dust.length > 700) dust.splice(0, dust.length - 700);
        kick();
      },
      smear: function (x, y, r) {
        if (!make()) return;
        lastStroke = performance.now(); cx.globalCompositeOperation = 'source-over';
        var g = cx.createRadialGradient(x, y, 0, x, y, r);
        g.addColorStop(0, 'rgba(250,246,239,0.075)'); g.addColorStop(1, 'rgba(250,246,239,0)');
        cx.fillStyle = g; cx.fillRect(x - r, y - r, r * 2, r * 2); kick();
      },
      boost: function (v) { if (!made) return; fadeBoost = Math.max(fadeBoost, v); kick(); }
    };
  })();
  window.addEventListener('scroll', function () { Chalk.boost(0.1); }, { passive: true });
  var lastPt = null;
  window.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'touch' || reduce) return;
    var t = e.target;
    var on = t && t.closest && t.closest('.nrb-board') && !t.closest('.nrb-paper,.nrb-pol,.nrb-note,.nrb-tt-cell,.nrb-sec-head,.nrb-filters,.nrb-list-foot,.nrb-standards,.nrb-std-note,.nrb-hero-copy,.nrb-hero-after,.nrb-code-pill,button,a,.nrb-qv');
    if (on && lastPt) {
      var dx = e.clientX - lastPt.x, dy = e.clientY - lastPt.y;
      if (dx * dx + dy * dy > 1.5) {
        Chalk.stroke(lastPt.x, lastPt.y, e.clientX, e.clientY);
        if (Math.random() < 0.35) Chalk.dust(e.clientX, e.clientY, 1, 6);
      }
    }
    lastPt = on ? { x: e.clientX, y: e.clientY } : null;
  }, { passive: true });

  /* ---------- chalk-rough SVG filter (injected once) ---------- */
  function ensureFilter() {
    if (document.getElementById('nrbChalkF')) return;
    var wrap = document.createElement('div');
    wrap.innerHTML = '<svg width="0" height="0" aria-hidden="true" focusable="false" style="position:absolute"><defs><filter id="nrbChalkF" x="-4%" y="-20%" width="108%" height="150%" color-interpolation-filters="sRGB"><feTurbulence type="fractalNoise" baseFrequency="1.1" numOctaves="2" seed="7" result="n"/><feDisplacementMap in="SourceGraphic" in2="n" scale="2.2" xChannelSelector="R" yChannelSelector="G"/></filter></defs></svg>';
    document.body.appendChild(wrap.firstChild);
  }

  /* ---------- chalk handwriting ---------- */
  function prepWrite(el) {
    if (el.getAttribute('data-nrb-prepped')) return;
    el.setAttribute('data-nrb-prepped', '1');
    var nodes = Array.prototype.slice.call(el.childNodes), idx = 0;
    nodes.forEach(function (n) {
      if (n.nodeType !== 3) return;
      var frag = document.createDocumentFragment();
      n.textContent.split(/(\s+)/).forEach(function (w) {
        if (!w) return;
        if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(' ')); return; }
        var wd = document.createElement('span'); wd.className = 'nrb-wd';
        for (var i = 0; i < w.length; i++) {
          var s = document.createElement('span'); s.className = 'nrb-ch'; s.textContent = w.charAt(i);
          s.style.setProperty('--nrb-i', idx++); wd.appendChild(s);
        }
        frag.appendChild(wd);
      });
      el.replaceChild(frag, n);
    });
  }
  function write(el, d0) {
    if (el.classList.contains('nrb-written')) return;
    d0 = d0 || 0;
    var step = parseFloat(el.getAttribute('data-nrb-step') || 40);
    el.style.setProperty('--nrb-d0', d0 + 'ms');
    el.style.setProperty('--nrb-step', step + 'ms');
    el.classList.add('nrb-written');
    if (reduce) return;
    each(el.querySelectorAll('.nrb-ch'), function (c, i) {
      setTimeout(function () {
        if (!el.classList.contains('nrb-written')) return;
        var r = c.getBoundingClientRect();
        if (r.width && r.top < window.innerHeight && r.bottom > 0) Chalk.dust(r.left + r.width / 2, r.top + r.height * 0.72, 5, r.width);
      }, d0 + i * step + 140);
    });
  }
  function unwrite(el) { el.classList.remove('nrb-written'); }

  /* ---------- reveals + write-on observers ---------- */
  var rvObs = io ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('nrb-in'); rvObs.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function observeRv(root) {
    each((root || document).querySelectorAll('.nrb-rv:not(.nrb-in)'), function (e) { rvObs ? rvObs.observe(e) : e.classList.add('nrb-in'); });
  }
  var wrObs = io ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { write(en.target, 80); wrObs.unobserve(en.target); } });
  }, { threshold: 0.4 }) : null;
  function scanWrite(root) {
    each((root || document).querySelectorAll('[data-nrb-write]'), function (e) {
      prepWrite(e);
      if (e.closest('[data-nrb-hero]')) return; /* the hero writes itself */
      if (e.__nrbWr) return; e.__nrbWr = true;
      wrObs ? wrObs.observe(e) : write(e, 0);
    });
  }

  /* ---------- copy buttons (delegated) ---------- */
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (res) {
      var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.left = '-9999px'; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) { }
      ta.remove(); res();
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nrb-copy]');
    if (!btn) return;
    var label = btn.getAttribute('data-nrb-label') || btn.textContent;
    btn.setAttribute('data-nrb-label', label);
    copyText(btn.getAttribute('data-nrb-copy')).then(function () {
      btn.classList.add('nrb-copied');
      btn.textContent = btn.getAttribute('data-nrb-copied-label') || T('copied');
      clearTimeout(btn.__t);
      btn.__t = setTimeout(function () { btn.classList.remove('nrb-copied'); btn.textContent = label; }, 1800);
    });
  });

  /* ---------- toast ---------- */
  var toastEl = null, toastT = null;
  function toast(html_, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nrbts nrb-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      copyHostVars(toastEl);
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html_;
    toastEl.style.borderColor = isError ? '#C0392B' : '';
    toastEl.classList.add('nrb-show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('nrb-show'); }, isError ? 4200 : 2800);
  }
  /* body-level singletons inherit the products section's palette overrides */
  function copyHostVars(el) {
    var host = document.querySelector('[data-nrb-products]');
    if (host) {
      var st = host.closest('.nrbts') ? host.closest('.nrbts').getAttribute('style') : null;
      if (st) el.setAttribute('style', st + (el.getAttribute('style') ? ';' + el.getAttribute('style') : ''));
    }
  }

  /* ---------- real cart: add + open the Crave cart drawer ---------- */
  function cartTarget() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.renderContents === 'function') {
      var ids = ['cart-drawer', 'cart-icon-bubble'];
      try { if (d.getSectionsToRender) ids = d.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { }
      return { el: d, ids: ids };
    }
    var n = document.querySelector('cart-notification');
    if (n && typeof n.renderContents === 'function') {
      var nids = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
      try { if (n.getSectionsToRender) nids = n.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { }
      return { el: n, ids: nids };
    }
    return null;
  }
  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function cartAdd(items) {
    var target = cartTarget();
    var payload = { items: items };
    if (target) {
      payload.sections = target.ids.join(',');
      payload.sections_url = window.location.pathname;
    }
    return fetch(routesRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok || data.status) {
          var msg = data.description || data.message || T('cartError');
          if (typeof msg === 'object') { try { msg = Object.keys(msg).map(function (k) { return msg[k]; }).join(' '); } catch (e) { msg = T('cartError'); } }
          var err = new Error(msg); err.__nrb = true; throw err;
        }
        if (target) {
          try {
            if (target.el.classList) target.el.classList.remove('is-empty');
            var inner = target.el.querySelector && target.el.querySelector('.drawer__inner');
            if (inner) inner.classList.remove('is-empty');
            if (typeof target.el.setActiveElement === 'function') target.el.setActiveElement(document.activeElement);
            target.el.renderContents(data);
          } catch (e) {
            window.location.href = routesRoot() + 'cart';
          }
        } else {
          window.location.href = routesRoot() + 'cart';
        }
        try {
          if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined' && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'nr-bts', cartData: data });
          }
        } catch (e) { }
        document.dispatchEvent(new CustomEvent('nrbts:cart:added', { detail: data }));
        return data;
      });
    });
  }

  /* fly-to-cart garnish aimed at the theme header cart icon */
  function cartIcon() {
    return document.getElementById('cart-icon-bubble') || document.querySelector('a[href$="/cart"], a[href*="/cart?"]');
  }
  function fly(img, cb) {
    cb = cb || function () { };
    var icon = cartIcon();
    if (!img || !icon || reduce || !img.animate || NRBTS.config.enableFly === false) { cb(); return; }
    var r = img.getBoundingClientRect(), c = icon.getBoundingClientRect();
    if (!r.width || !c.width) { cb(); return; }
    var g = document.createElement('img');
    g.src = img.currentSrc || img.src; g.className = 'nrbts nrb-fly';
    g.style.cssText = 'left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;';
    document.body.appendChild(g);
    var dx = (c.left + c.width / 2) - (r.left + r.width / 2), dy = (c.top + c.height / 2) - (r.top + r.height / 2);
    g.animate([
      { transform: 'translate(0,0) scale(1) rotate(0)', opacity: 1 },
      { transform: 'translate(' + (dx * 0.45) + 'px,' + (dy * 0.45 - 140) + 'px) scale(.4) rotate(-6deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.05) rotate(8deg)', opacity: 0.5 }
    ], { duration: 820, easing: 'cubic-bezier(.3,.6,.2,1)' }).onfinish = function () {
      g.remove();
      var cr = icon.getBoundingClientRect();
      Chalk.dust(cr.left + cr.width / 2, cr.top + cr.height / 2, 10, cr.width);
      cb();
    };
  }

  function flashBtn(btn, txt) {
    var orig = btn.getAttribute('data-nrb-orig') || btn.innerHTML;
    btn.setAttribute('data-nrb-orig', orig);
    btn.classList.add('nrb-added');
    btn.innerHTML = esc(txt || T('addedShort'));
    clearTimeout(btn.__ft);
    btn.__ft = setTimeout(function () { btn.classList.remove('nrb-added'); btn.innerHTML = orig; }, 1400);
  }

  /* simple add (grid / timetable buttons) */
  function quickAdd(btn, productId) {
    var p = getProduct(productId);
    if (!p) return;
    var v = firstAvailableVariant(p);
    if (!v) return;
    var host = btn.closest('.nrb-pol, .nrb-tt-card');
    var img = host ? host.querySelector('img') : null;
    btn.disabled = true;
    fly(img, function () { });
    cartAdd([{ id: v.id, quantity: 1 }]).then(function () {
      btn.disabled = false;
      if (btn.classList.contains('nrb-tt-add')) {
        btn.classList.add('nrb-added');
        setTimeout(function () { btn.classList.remove('nrb-added'); }, 1400);
      } else flashBtn(btn, T('addedShort'));
      if (NRBTS.config.showToast) {
        toast('<img src="' + esc(p.img) + '" alt=""><div><b>' + esc(p.title) + '</b><small>' + T('addedToast').replace('{price}', money(withCode(v.price))) + '</small></div>');
      }
    }).catch(function (err) {
      btn.disabled = false;
      toast('<div><b>' + esc(err && err.message ? err.message : T('cartError')) + '</b></div>', true);
    });
  }
  function firstAvailableVariant(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return null;
  }

  /* =========================================================
     Quick view modal — built from registered product JSON,
     buying through the real cart with real selling plans.
     ========================================================= */
  function byHandle(handle) {
    for (var id in NRBTS.products) { if (NRBTS.products[id].handle === handle) return NRBTS.products[id]; }
    return null;
  }
  function nutriTable(n) {
    if (!n) return '';
    var rows = [['cal', 'Calories', ''], ['fat', 'Total fat', ' g'], ['sat', 'Saturated fat', ' g'], ['chol', 'Cholesterol', ' mg'], ['sod', 'Sodium', ' mg'], ['carb', 'Carbohydrate', ' g'], ['pro', 'Protein', ' g']];
    var any = rows.some(function (r) { return n[r[0]] != null && n[r[0]] !== ''; });
    if (!any) return '';
    return '<table class="nrb-qv-nutri">' + (n.serv ? '<caption>Per ' + esc(n.serv) + '</caption>' : '') +
      rows.map(function (r) {
        if (n[r[0]] == null || n[r[0]] === '') return '';
        return '<tr class="' + (r[0] === 'cal' ? 'nrb-cal' : r[0] === 'sat' ? 'nrb-ind' : '') + '"><th>' + r[1] + '</th><td>' + esc(n[r[0]]) + r[2] + '</td></tr>';
      }).join('') + '</table><p class="nrb-qv-nn">' + esc(T('nutritionNote')) + '</p>';
  }
  function bars(d) {
    if (!d || !d.length || !d.some(function (v) { return v > 0; })) return '';
    return '<div class="nrb-qv-bars">' + d.map(function (v, i) {
      var s = 5 - i;
      return '<span>' + s + '★</span><i style="--nrb-w:' + v + '%"></i><span>' + v + '%</span>';
    }).join('') + '</div>';
  }
  function pickBump(p) {
    var pool = (NRBTS.config.bumps || []).filter(function (b) {
      return b.available && b.productId !== p.id;
    });
    if (!pool.length) return null;
    return pool[Math.floor(Math.random() * pool.length)];
  }
  function codeBoxHtml(v) {
    if (!NRBTS.config.code || !parseFloat(NRBTS.config.pct)) return '';
    var line = esc(T('withCodeAtCheckout')).replace('{code}', '<code>' + esc(NRBTS.config.code) + '</code>');
    return '<div class="nrb-qv-code" data-nrb-qv-code><span><b>' + money(withCode(v.price)) + '</b> ' + line + '</span>' +
      '<button class="nrb-copy-btn" type="button" data-nrb-copy="' + esc(NRBTS.config.code) + '" style="color:var(--nrb-ink);padding:0;min-width:0;font-size:11px">' + esc(T('copyCode')) + '</button></div>';
  }
  function qvTemplate(p, st) {
    var v = variantById(p, st.variantId);
    var save = v.compare > v.price ? Math.round((1 - v.price / v.compare) * 100) : 0;
    var saveAmt = v.compare > v.price ? v.compare - v.price : 0;
    var f = farmFor(p);
    var weight = parseFloat(p.weightLb) || 0;
    var dinners = weight ? Math.max(1, Math.round(weight * 1.3)) : 0;
    var bump = st.bumpItem;
    var reviews = NRBTS.config.reviews || [];
    var hasOwnRating = p.rating && p.count;
    var ratingVal = p.rating || NRBTS.config.storeRating || '';
    var ratingCount = hasOwnRating ? p.count + ' ' + T('reviewsLabel') : (NRBTS.config.storeCount ? NRBTS.config.storeCount + ' ' + T('reviewsLabel') : T('reviewsFallbackLabel'));
    var slides = '<div class="nrb-qv-slide"><img src="' + esc(p.imgLarge || p.img) + '" alt="' + esc(p.title) + '" data-nrb-qv-img></div>';
    var thumbs = '<button class="nrb-qv-thumb nrb-on" type="button" data-nrb-qv-thumb="0"><img src="' + esc(p.img) + '" alt="">' + esc(T('photoTab')) + '</button>';
    var slideCount = 1;
    var farmThumbIdx = -1;
    if (f && f.photo) {
      farmThumbIdx = slideCount;
      slides += '<div class="nrb-qv-slide"><div class="nrb-qv-card"><img class="nrb-bg" src="' + esc(f.photo) + '" alt="" loading="lazy">' +
        (f.badge ? '<span class="nrb-badge"><img src="' + esc(f.badge) + '" alt=""></span>' : '') +
        '<span class="nrb-est">' + esc(f.place) + (f.since ? ' · ' + esc(T('since')) + ' ' + esc(f.since) : '') + '</span>' +
        '<h3>' + esc(f.name) + '</h3>' + (f.blurb ? '<p>' + esc(f.blurb) + '</p>' : '') +
        (f.url ? '<a href="' + esc(f.url) + '" target="_blank" rel="noopener">' + esc(T('readStory')) + '</a>' : '') + '</div></div>';
      thumbs += '<button class="nrb-qv-thumb" type="button" data-nrb-qv-thumb="' + slideCount + '">' + (f.badge ? '<img src="' + esc(f.badge) + '" alt="">' : '<span class="nrb-sw">✦</span>') + esc(T('farmTab')) + '</button>';
      slideCount++;
    }
    if (p.box && p.box.length) {
      slides += '<div class="nrb-qv-slide"><div class="nrb-qv-card nrb-box"><span class="nrb-est">' + esc(T('boxSlideEyebrow')) + '</span><ul>' + p.box.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul></div></div>';
      thumbs += '<button class="nrb-qv-thumb" type="button" data-nrb-qv-thumb="' + slideCount + '"><span class="nrb-sw">▤</span>' + esc(T('boxTab')) + '</button>';
      slideCount++;
    }
    slides += '<div class="nrb-qv-slide"><div class="nrb-qv-card nrb-promise"><span class="nrb-shield">✓</span><span class="nrb-est">' + esc(T('promiseSlideEyebrow')) + '</span><h3>' + esc(T('promiseSlideTitle')) + '</h3><p>' + T('promiseHtml') + '</p></div></div>';
    thumbs += '<button class="nrb-qv-thumb" type="button" data-nrb-qv-thumb="' + slideCount + '"><span class="nrb-sw">✓</span>' + esc(T('promiseTab')) + '</button>';

    return '<button class="nrb-qv-close" type="button" data-nrb-qv-close aria-label="' + esc(T('close')) + '">×</button>' +
      '<div class="nrb-qv-gallery">' +
      '<div class="nrb-qv-badges">' + (save ? '<span class="nrb-qv-badge nrb-sale">Save ' + save + '%</span>' : '') +
      (p.limited ? '<span class="nrb-qv-badge nrb-cert">' + esc(p.limited) + '</span>' : '') +
      (p.cert ? '<span class="nrb-qv-badge nrb-cert">' + esc(p.cert) + '</span>' : '') + '</div>' +
      '<div class="nrb-qv-slides" data-nrb-qv-slides>' + slides + '</div>' +
      '<div class="nrb-qv-thumbs">' + thumbs + '</div>' +
      '</div>' +
      '<div class="nrb-qv-buy" data-nrb-qv-buy>' +
      (f ? '<button class="nrb-qv-farmchip" type="button" ' + (farmThumbIdx > -1 ? 'data-nrb-qv-thumb="' + farmThumbIdx + '"' : 'data-nrb-qv-farmlink="' + esc(f.url) + '"') + '><span class="nrb-pin"><svg viewBox="0 0 24 24"><path d="M12 22s7-6.5 7-12a7 7 0 0 0-14 0c0 5.5 7 12 7 12z"/><circle cx="12" cy="10" r="2.5"/></svg></span>' + esc(T('raisedAt')) + ' ' + esc(f.name) + (f.place ? ', ' + esc(f.place) : '') + ' <u>' + esc(T('traceIt')) + '</u></button>' : '') +
      '<h2 id="nrbQvTitle">' + esc(p.title) + '</h2>' +
      (p.desc ? '<div class="nrb-qv-sub">' + esc(p.desc) + '</div>' : '') +
      (ratingVal ? '<button class="nrb-qv-rating" type="button" data-nrb-qv-reviews><span class="nrb-stars">' + stars() + '</span> ' + esc(ratingVal) + ' <u>' + esc(ratingCount) + '</u></button>' : '') +
      '<div class="nrb-qv-pricerow"><span class="nrb-now" data-nrb-qv-price>' + money(v.price) + '</span>' +
      (saveAmt ? '<s>' + money(v.compare) + '</s><span class="nrb-qv-pill">' + esc(T('youSave')) + ' ' + money(saveAmt) + '</span>' : '') + '</div>' +
      codeBoxHtml(v) +
      (weight ? '<div class="nrb-qv-perlb"><b>' + money(Math.round(v.price / weight)) + esc(T('perLb')) + '</b>, ' + esc(T('about')) + ' <b>' + money(Math.round(v.price / dinners)) + '</b> ' + esc(T('perDinner')) + ', ' + dinners + ' ' + esc(T('dinnersABox')) + '</div>' : '') +
      (p.variants.length > 1 ? '<label class="nrb-qv-vsel">' + esc(T('optionLabel')) + '<select data-nrb-qv-variant>' + p.variants.map(function (vv) {
        return '<option value="' + vv.id + '"' + (vv.id === v.id ? ' selected' : '') + (vv.available ? '' : ' disabled') + '>' + esc(vv.title) + (vv.available ? '' : ' (' + T('soldOut') + ')') + '</option>';
      }).join('') + '</select></label>' : '') +
      (bump ? '<label class="nrb-qv-bump"><input type="checkbox" data-nrb-qv-bump><img src="' + esc(bump.img) + '" alt=""><span><b>Add ' + esc(bump.title) + '</b> ' + money(bump.price) + (bump.compare > bump.price ? ' <s>' + money(bump.compare) + '</s>' : '') + (NRBTS.config.bumpNote ? '<small>' + esc(NRBTS.config.bumpNote) + '</small>' : '') + '</span></label>' : '') +
      '<div class="nrb-qv-buyrow"><div class="nrb-qv-qty" aria-label="Quantity"><button type="button" data-nrb-qv-minus aria-label="' + esc(T('decrease')) + '">−</button><output data-nrb-qv-qty>1</output><button type="button" data-nrb-qv-plus aria-label="' + esc(T('increase')) + '">+</button></div>' +
      '<button class="nrb-qv-atc" type="button" data-nrb-qv-atc' + (v.available ? '' : ' disabled') + '>' + (v.available ? esc(T('addToCart')) : esc(T('soldOut'))) + '</button></div>' +
      '<p class="nrb-atc-error" data-nrb-qv-error role="alert"></p>' +
      '<div class="nrb-qv-notes">' + (T('note1') ? '<span>' + esc(T('note1')) + '</span>' : '') + (T('note2') ? '<span>' + esc(T('note2')) + '</span>' : '') + '</div>' +
      (NRBTS.config.showDelivery !== false ? '<div class="nrb-qv-delivery"><div class="nrb-head"><span>' + esc(T('orderNext')) + ' <span class="nrb-cd" data-nrb-qv-cd>--h --m</span></span><span>' + esc(T('earliest')) + '</span></div>' +
        '<div class="nrb-qv-route"><span>' + esc((f && f.place) || 'The farm') + '</span><span>' + esc(T('routeMid')) + '</span><span>' + esc(T('routeEnd')) + '</span></div>' +
        '<p class="nrb-qv-fine">' + esc(T('deliveryFine')) + '</p></div>' : '') +
      '<div class="nrb-qv-promise"><span class="nrb-shield">✓</span><div>' + T('promiseHtml') + '</div></div>' +
      '<div class="nrb-qv-acc">' +
      '<details open><summary>' + esc(T('boxTitle')) + '</summary><div class="nrb-body">' + (p.box && p.box.length ? '<ul>' + p.box.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul>' : T('boxFallback')) + '</div></details>' +
      '<details><summary>' + esc(T('nutritionTitle')) + '</summary><div class="nrb-body">' + (nutriTable(p.nutri) || '<p>' + T('nutritionFallback') + '</p>') + '</div></details>' +
      (T('shippingHtml') ? '<details><summary>' + T('shippingTitle') + '</summary><div class="nrb-body">' + T('shippingHtml') + '</div></details>' : '') +
      '</div>' +
      (reviews.length || ratingVal ? '<section class="nrb-qv-reviews" data-nrb-qv-reviews-sec><span class="nrb-eyebrow">' + esc(T('reviewsEyebrow')) + '</span>' +
        '<div class="nrb-qv-rhead"><span class="nrb-big">' + esc(ratingVal) + '</span><div><span class="nrb-stars">' + stars() + '</span><small>' + esc(ratingCount) + ' · ' + esc(T('viaLoox')) + '</small></div></div>' +
        (hasOwnRating ? '' : bars(NRBTS.config.dist)) +
        reviews.map(function (r) {
          return '<div class="nrb-qv-review"><div class="nrb-stars">' + stars() + '</div><p>' + esc(r.text) + '</p><div class="nrb-who"><b>' + esc(r.name) + '</b>' + (r.loc ? '<span>' + esc(r.loc) + '</span>' : '') + '<span class="nrb-v">' + esc(T('verifiedBuyer')) + '</span></div></div>';
        }).join('') +
        '<div class="nrb-qv-rfoot"><a href="' + esc(p.url) + '#nr-reviews" target="_blank" rel="noopener">' + esc(T('readAll')) + '</a><small>' + esc(hasOwnRating ? T('collectedBy') : T('storeNote')) + '</small></div>' +
        '</section>' : '') +
      '<a class="nrb-qv-full" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + esc(T('fullPage')) + '</a>' +
      '</div>' +
      '<div class="nrb-qv-sticky"><div><b data-nrb-qv-sticky-price>' + money(v.price) + '</b><span>' + esc(p.title.length > 34 ? p.title.slice(0, 32) + '…' : p.title) + '</span></div><button type="button" data-nrb-qv-atc' + (v.available ? '' : ' disabled') + '>' + (v.available ? esc(T('addToCart')) : esc(T('soldOut'))) + '</button></div>';
  }
  function variantById(p, id) {
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i];
    return p.variants[0];
  }

  var QV = (function () {
    var qv = null, panel = null, cur = null, st = null, lastFocus = null, cdT = null, histState = false, hideT = null;
    function ensure() {
      if (qv) return;
      qv = document.createElement('div');
      qv.className = 'nrbts nrb-qv';
      qv.id = 'nrbQv';
      qv.setAttribute('role', 'dialog');
      qv.setAttribute('aria-modal', 'true');
      qv.setAttribute('aria-labelledby', 'nrbQvTitle');
      qv.hidden = true;
      qv.innerHTML = '<div class="nrb-qv-backdrop" data-nrb-qv-close></div><div class="nrb-qv-panel" id="nrbQvPanel"></div>';
      copyHostVars(qv);
      document.body.appendChild(qv);
      panel = qv.querySelector('#nrbQvPanel');
      bind();
    }
    function cdText() {
      var tz = NRBTS.config.countdownTz || 'America/Toronto';
      try {
        var s = new Date().toLocaleString('en-US', { timeZone: tz, hour12: false });
        var m = s.match(/(\d{1,2}):(\d{2}):(\d{2})/);
        if (!m) return '';
        var mins = (23 * 60 + 59) - ((+m[1] % 24) * 60 + (+m[2]));
        if (mins < 0) mins = 0;
        return Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm';
      } catch (e) { return ''; }
    }
    function startCountdown() {
      clearInterval(cdT);
      var tick = function () { var el = panel.querySelector('[data-nrb-qv-cd]'); if (el) el.textContent = cdText(); };
      tick(); cdT = setInterval(tick, 30000);
    }
    function apply() {
      if (!cur) return;
      var v = variantById(cur, st.variantId);
      var unit = v.price;
      var bumpPrice = st.bump && st.bumpItem ? st.bumpItem.price : 0;
      var total = unit * st.qty + bumpPrice;
      var pr = panel.querySelector('[data-nrb-qv-price]'); if (pr) pr.innerHTML = money(unit);
      each(panel.querySelectorAll('[data-nrb-qv-atc]'), function (b) {
        if (b.disabled) return;
        b.innerHTML = esc(T('addToCart')) + ' · ' + money(total);
      });
      var sk = panel.querySelector('[data-nrb-qv-sticky-price]'); if (sk) sk.innerHTML = money(unit);
      var q = panel.querySelector('[data-nrb-qv-qty]'); if (q) q.textContent = st.qty;
    }
    function goSlide(i) {
      var s = panel.querySelector('[data-nrb-qv-slides]'); if (!s) return;
      s.scrollTo({ left: i * s.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      markThumb(i);
    }
    function markThumb(i) {
      each(panel.querySelectorAll('[data-nrb-qv-thumb]'), function (t) {
        if (t.classList.contains('nrb-qv-thumb')) t.classList.toggle('nrb-on', +t.getAttribute('data-nrb-qv-thumb') === i);
      });
    }
    function open(idOrHandle, opts) {
      ensure();
      var p = getProduct(idOrHandle) || byHandle(idOrHandle);
      if (!p || !p.variants || !p.variants.length) return;
      opts = opts || {};
      clearTimeout(hideT);
      if (qv.hidden) lastFocus = document.activeElement;
      cur = p;
      var v0 = firstAvailableVariant(p) || p.variants[0];
      st = { variantId: v0.id, qty: 1, bump: false, bumpItem: pickBump(p) };
      panel.innerHTML = qvTemplate(p, st);
      qv.hidden = false;
      html.classList.add('nrb-qv-lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { qv.classList.add('nrb-open'); }); });
      apply(); startCountdown();
      if (!opts.fromHistory) {
        try { history.pushState({ nrbQv: p.handle }, '', '#qv-' + p.handle); histState = true; } catch (e) { }
      }
      setTimeout(function () { var c = panel.querySelector('.nrb-qv-close'); if (c) c.focus({ preventScroll: true }); }, 80);
    }
    function close(viaHistory) {
      if (!qv || qv.hidden) return;
      qv.classList.remove('nrb-open');
      clearInterval(cdT);
      hideT = setTimeout(function () { qv.hidden = true; html.classList.remove('nrb-qv-lock'); panel.innerHTML = ''; }, 380);
      if (!viaHistory && histState) { histState = false; try { history.back(); } catch (e) { } }
      histState = false; cur = null;
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { } }
    }
    function bind() {
      window.addEventListener('popstate', function (e) {
        if (e.state && e.state.nrbQv) { open(e.state.nrbQv, { fromHistory: true }); histState = true; }
        else if (qv && !qv.hidden) close(true);
      });
      qv.addEventListener('click', function (e) {
        if (e.target.closest('[data-nrb-qv-close]')) { close(); return; }
        var fl = e.target.closest('[data-nrb-qv-farmlink]');
        if (fl) { var u = fl.getAttribute('data-nrb-qv-farmlink'); if (u) window.open(u, '_blank', 'noopener'); return; }
        var th = e.target.closest('[data-nrb-qv-thumb]');
        if (th) { goSlide(+th.getAttribute('data-nrb-qv-thumb')); return; }
        if (e.target.closest('[data-nrb-qv-reviews]')) {
          var sec = panel.querySelector('[data-nrb-qv-reviews-sec]');
          if (sec) sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          return;
        }
        if (e.target.closest('[data-nrb-qv-minus]')) { st.qty = Math.max(1, st.qty - 1); apply(); return; }
        if (e.target.closest('[data-nrb-qv-plus]')) { st.qty = Math.min(NRBTS.config.qtyMax || 10, st.qty + 1); apply(); return; }
        var atc = e.target.closest('[data-nrb-qv-atc]');
        if (atc && !atc.disabled) {
          var items = [{ id: st.variantId, quantity: st.qty }];
          if (st.bump && st.bumpItem) items.push({ id: st.bumpItem.variantId, quantity: 1 });
          var errEl = panel.querySelector('[data-nrb-qv-error]');
          if (errEl) errEl.textContent = '';
          atc.disabled = true;
          atc.innerHTML = esc(T('adding'));
          fly(panel.querySelector('[data-nrb-qv-img]'), function () { });
          cartAdd(items).then(function () {
            atc.disabled = false;
            atc.classList.add('nrb-added');
            atc.innerHTML = esc(T('added'));
            setTimeout(function () { atc.classList.remove('nrb-added'); apply(); }, 1500);
          }).catch(function (err) {
            atc.disabled = false;
            apply();
            if (errEl) errEl.textContent = err && err.message ? err.message : T('cartError');
          });
          return;
        }
      });
      qv.addEventListener('change', function (e) {
        if (e.target.hasAttribute('data-nrb-qv-bump')) { st.bump = e.target.checked; apply(); }
        else if (e.target.hasAttribute('data-nrb-qv-variant')) {
          st.variantId = +e.target.value;
          var scroll = panel.querySelector('.nrb-qv-buy') ? panel.querySelector('.nrb-qv-buy').scrollTop : 0;
          panel.innerHTML = qvTemplate(cur, st);
          apply(); startCountdown();
          var buy = panel.querySelector('.nrb-qv-buy'); if (buy) buy.scrollTop = scroll;
        }
      });
      qv.addEventListener('scroll', function (e) {
        if (e.target.hasAttribute && e.target.hasAttribute('data-nrb-qv-slides')) {
          var s = e.target;
          markThumb(Math.round(s.scrollLeft / Math.max(1, s.clientWidth)));
        }
      }, true);
      document.addEventListener('keydown', function (e) {
        if (!qv || qv.hidden) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key === 'Tab') {
          var f = panel.querySelectorAll('button,[href],select,input,[tabindex]:not([tabindex="-1"])');
          var list = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
          if (!list.length) return;
          var first = list[0], last = list[list.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
    return { open: open, close: close };
  })();
  NRBTS.openQuickView = QV.open;

  /* ---------- global delegated clicks: add + open ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-nrb-add]');
    if (add && !add.disabled) {
      e.preventDefault(); e.stopPropagation();
      quickAdd(add, add.getAttribute('data-nrb-add'));
      return;
    }
    var open = e.target.closest('[data-nrb-open]');
    if (open) {
      var id = open.getAttribute('data-nrb-open');
      if (getProduct(id) || byHandle(id)) {
        e.preventDefault();
        QV.open(id);
      }
      /* if the product isn't registered, let the link navigate normally */
    }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[data-nrb-open][role="button"]')) {
      e.preventDefault();
      QV.open(e.target.getAttribute('data-nrb-open'));
    }
  });

  /* ---------- product grid filters (category chips x use chips) ---------- */
  function initFilters(root) {
    if (root.__nrbFilters) return;
    root.__nrbFilters = true;
    var state = { cat: 'all', use: 'all' };
    var grid = root.querySelector('[data-nrb-grid]');
    var countEl = root.querySelector('[data-nrb-count]');
    var emptyEl = root.querySelector('[data-nrb-empty]');
    if (!grid) return;
    function apply() {
      var n = 0;
      each(grid.querySelectorAll('.nrb-pol'), function (c) {
        var cats = (c.getAttribute('data-cats') || '').split(' ');
        var tags = (c.getAttribute('data-tags') || '').split(' ');
        var show = (state.cat === 'all' || cats.indexOf(state.cat) > -1) && (state.use === 'all' || tags.indexOf(state.use) > -1);
        if (show) {
          n++;
          if (c.classList.contains('nrb-is-hidden')) {
            c.classList.add('nrb-fade-out'); c.classList.remove('nrb-is-hidden');
            requestAnimationFrame(function () { requestAnimationFrame(function () { c.classList.remove('nrb-fade-out'); }); });
          } else c.classList.remove('nrb-fade-out');
          c.classList.add('nrb-in');
        } else {
          c.classList.add('nrb-fade-out');
          setTimeout(function () { if (c.classList.contains('nrb-fade-out')) c.classList.add('nrb-is-hidden'); }, 340);
        }
      });
      if (countEl) countEl.textContent = n + ' ' + (n === 1 ? (countEl.getAttribute('data-one') || 'product') : (countEl.getAttribute('data-many') || 'products'));
      if (emptyEl) emptyEl.hidden = n > 0;
    }
    function chipGroup(sel, attr, key) {
      var g = root.querySelector(sel);
      if (!g) return;
      g.addEventListener('click', function (e) {
        var ch = e.target.closest('.nrb-chip'); if (!ch) return;
        each(g.querySelectorAll('.nrb-chip'), function (o) { o.setAttribute('aria-pressed', 'false'); });
        ch.setAttribute('aria-pressed', 'true');
        state[key] = ch.getAttribute(attr);
        apply();
      });
    }
    chipGroup('[data-nrb-cat-filters]', 'data-nrb-cat', 'cat');
    chipGroup('[data-nrb-use-filters]', 'data-nrb-use', 'use');
    apply();
  }

  /* ---------- scroll-reactive ticker ---------- */
  function initTicker(root) {
    if (root.__nrbTicker) return;
    root.__nrbTicker = true;
    var track = root.querySelector('[data-nrb-ticker-track]');
    if (!track || reduce) return;
    var x = 0, half = 0, vel = 0, ly = window.scrollY, lt = performance.now(), onscreen = true;
    function measure() { half = track.scrollWidth / 2; }
    measure(); window.addEventListener('resize', measure);
    window.addEventListener('scroll', function () { var y = window.scrollY; vel += (y - ly) * 0.9; ly = y; }, { passive: true });
    if (io) new IntersectionObserver(function (en) { onscreen = en[0].isIntersecting; }, { threshold: 0 }).observe(root);
    (function tick(now) {
      var dt = Math.min(0.05, (now - lt) / 1000); lt = now; vel *= 0.9;
      if (onscreen && half) {
        var speed = 70 + Math.max(-1000, Math.min(1000, vel * 3));
        x -= speed * dt;
        if (x <= -half) x += half;
        if (x > 0) x -= half;
        track.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      }
      requestAnimationFrame(tick);
    })(performance.now());
  }

  /* ---------- sticky offer slip visibility ---------- */
  function initSlip(root) {
    if (root.__nrbSlip) return;
    root.__nrbSlip = true;
    var heroWrap = document.querySelector('[data-nrb-hero-wrap]');
    var finalSec = document.querySelector('[data-nrb-final]');
    if (io && (heroWrap || finalSec)) {
      var heroVis = !!heroWrap, finalVis = false;
      var upd = function () { root.classList.toggle('nrb-show', !heroVis && !finalVis); };
      if (heroWrap) new IntersectionObserver(function (en) { heroVis = en[0].isIntersecting; upd(); }, { threshold: 0.02 }).observe(heroWrap);
      if (finalSec) new IntersectionObserver(function (en) { finalVis = en[0].isIntersecting; upd(); }, { threshold: 0.2 }).observe(finalSec);
      if (!heroWrap) upd();
    } else {
      var onScroll = function () { root.classList.toggle('nrb-show', window.scrollY > 600); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- the bell ---------- */
  function initBell(root) {
    if (root.__nrbBell || !io) return;
    root.__nrbBell = true;
    new IntersectionObserver(function (en) {
      if (en[0].isIntersecting) {
        root.classList.add('nrb-ring');
        var r = root.getBoundingClientRect();
        Chalk.dust(r.left + r.width / 2, r.bottom - 6, 14, r.width);
      } else root.classList.remove('nrb-ring');
    }, { threshold: 0.9 }).observe(root);
  }

  /* =========================================================
     Hero: 3D chalkboard, floating supplies, scroll packs the box
     ========================================================= */
  function initHero(hero) {
    if (hero.__nrbHero) return;
    hero.__nrbHero = true;
    var heroWrap = hero.closest('[data-nrb-hero-wrap]') || hero.parentElement;
    var copy = hero.querySelector('[data-nrb-hero-copy]');
    var canvas = hero.querySelector('[data-nrb-hero-canvas]');
    var afterEl = hero.querySelector('[data-nrb-after-write]');
    var want3d = hero.getAttribute('data-nrb-3d') !== 'false';

    /* entrance: start once fonts are ready (or after a short timeout) */
    var started = false, onReady = [];
    function start() {
      if (started) return;
      started = true;
      document.body.classList.add('nrb-ready');
      each(hero.querySelectorAll('.nrb-hero-title [data-nrb-write]'), function (el) {
        write(el, parseFloat(el.getAttribute('data-nrb-d0') || 0));
      });
      onReady.forEach(function (f) { f(); });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(start);
    setTimeout(start, 700);

    if (!canvas || !want3d) { html.classList.add('nrb-no3d'); return; }
    if (window.THREE) { boot3D(); }
    else {
      var threeTag = document.querySelector('script[data-nrb-three]');
      if (threeTag) {
        threeTag.addEventListener('load', function () { if (window.THREE) { html.classList.remove('nrb-no3d'); boot3D(); } });
        threeTag.addEventListener('error', function () { html.classList.add('nrb-no3d'); });
        setTimeout(function () { if (!window.THREE && !hero.__nrb3d) html.classList.add('nrb-no3d'); }, 4000);
      } else html.classList.add('nrb-no3d');
    }
    function boot3D() {
    if (hero.__nrb3d) return;
    hero.__nrb3d = true;
    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true, powerPreference: 'high-performance' });
    } catch (e) { html.classList.add('nrb-no3d'); return; }
    var mob0 = window.innerWidth < 900;
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, mob0 ? 1.6 : 2));
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.08;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    function pal(name, fallback) {
      try {
        var v = getComputedStyle(hero).getPropertyValue(name).trim();
        if (/^#([0-9a-f]{6})$/i.test(v)) return parseInt(v.slice(1), 16);
      } catch (e) { }
      return fallback;
    }
    var C_BOARD = pal('--nrb-board', 0x0a3c2c), C_CORAL = pal('--nrb-coral', 0xf56852), C_CORALD = pal('--nrb-coral-deep', 0xe2553f), C_CREAM = pal('--nrb-chalk', 0xfaf6ef);
    function lin(h) { return new THREE.Color(h).convertSRGBToLinear(); }
    var scene = new THREE.Scene();
    scene.fog = new THREE.Fog(lin(C_BOARD), 11, 22);
    var camera = new THREE.PerspectiveCamera(30, 1, 0.1, 80);
    camera.position.set(0, 0, 14);
    scene.add(new THREE.HemisphereLight(lin(0xfff8ea), lin(0x1c5a45), 0.95));
    var key = new THREE.DirectionalLight(lin(0xfff1dc), 1.3);
    key.position.set(-6, 8, 10); key.castShadow = true;
    key.shadow.mapSize.set(mob0 ? 512 : 1024, mob0 ? 512 : 1024);
    var sc = key.shadow.camera;
    sc.left = -14; sc.right = 14; sc.top = 10; sc.bottom = -10; sc.near = 1; sc.far = 40;
    key.shadow.bias = -0.0006; key.shadow.normalBias = 0.03;
    scene.add(key);
    var fill = new THREE.DirectionalLight(lin(0xd9ecdf), 0.35); fill.position.set(6, -2, 5); scene.add(fill);
    var rim = new THREE.DirectionalLight(lin(C_CORAL), 0.3); rim.position.set(2, -6, -6); scene.add(rim);
    scene.add(new THREE.AmbientLight(0xffffff, 0.18));
    var floorMat = new THREE.ShadowMaterial({ opacity: 0.3 }); floorMat.fog = false;
    var floor = new THREE.Mesh(new THREE.PlaneGeometry(90, 60), floorMat);
    floor.position.z = -5.5; floor.receiveShadow = true; scene.add(floor);

    function M(c, r, extra) {
      var o = { color: lin(c), roughness: r == null ? 0.6 : r, metalness: 0 };
      if (extra) for (var k in extra) o[k] = extra[k];
      return new THREE.MeshStandardMaterial(o);
    }
    var mat = { coral: M(C_CORAL, 0.5), coralDeep: M(C_CORALD, 0.5), cream: M(C_CREAM, 0.75), page: M(0xf1e8d6, 0.9), green: M(C_BOARD, 0.55), deep: M(0x06271d, 0.5), leaf: M(0x2f6b4f, 0.7), wood: M(0xe8d8bb, 0.85), graphite: M(0x1b2622, 0.35), metal: M(0xcfc7b8, 0.35, { metalness: 0.6 }), chalk: M(0xfffdf7, 0.95), felt: M(0xf3eadb, 0.95) };
    function shadowed(g) { g.traverse(function (o) { if (o.isMesh) o.castShadow = true; }); return g; }

    function makePencil() {
      var g = new THREE.Group();
      g.add(new THREE.Mesh(new THREE.CylinderGeometry(0.14, 0.14, 2.6, 6), mat.coral));
      var wood = new THREE.Mesh(new THREE.CylinderGeometry(0.14, 0.05, 0.34, 6), mat.wood); wood.position.y = -1.47; g.add(wood);
      var tip = new THREE.Mesh(new THREE.ConeGeometry(0.05, 0.16, 6), mat.graphite); tip.rotation.x = Math.PI; tip.position.y = -1.72; g.add(tip);
      var ferrule = new THREE.Mesh(new THREE.CylinderGeometry(0.15, 0.15, 0.2, 18), mat.metal); ferrule.position.y = 1.4; g.add(ferrule);
      var eraser = new THREE.Mesh(new THREE.CylinderGeometry(0.14, 0.14, 0.24, 18), mat.cream); eraser.position.y = 1.62; g.add(eraser);
      return shadowed(g);
    }
    function makeApple() {
      var g = new THREE.Group();
      var body = new THREE.Mesh(new THREE.SphereGeometry(0.62, 36, 28), mat.coral); body.scale.set(1, 0.9, 1); g.add(body);
      var dimple = new THREE.Mesh(new THREE.SphereGeometry(0.2, 16, 12), mat.coralDeep); dimple.position.y = 0.5; dimple.scale.set(1, 0.35, 1); g.add(dimple);
      var stem = new THREE.Mesh(new THREE.CylinderGeometry(0.03, 0.04, 0.36, 8), mat.deep); stem.position.set(0.02, 0.7, 0); stem.rotation.z = 0.2; g.add(stem);
      var leaf = new THREE.Mesh(new THREE.SphereGeometry(0.2, 16, 12), mat.leaf); leaf.scale.set(1.4, 0.18, 0.6); leaf.position.set(0.22, 0.74, 0.02); leaf.rotation.z = -0.45; g.add(leaf);
      return shadowed(g);
    }
    function rulerTexture() {
      var c = document.createElement('canvas'); c.width = 1024; c.height = 160;
      var x = c.getContext('2d');
      x.fillStyle = '#faf6ef'; x.fillRect(0, 0, 1024, 160);
      x.strokeStyle = '#0a3c2c'; x.fillStyle = '#0a3c2c'; x.textAlign = 'center';
      x.font = '600 26px "IBM Plex Mono", Menlo, monospace';
      for (var i = 0; i <= 31; i++) {
        var px = 16 + i * 32, major = i % 5 === 0;
        x.lineWidth = major ? 4 : 2.5;
        x.beginPath(); x.moveTo(px, 0); x.lineTo(px, major ? 62 : 34); x.stroke();
        if (major) x.fillText(String(i / 5), px, 100);
      }
      x.lineWidth = 2;
      for (var j = 0; j < 62; j++) { if (j % 2) { var q = 16 + j * 16; x.beginPath(); x.moveTo(q, 0); x.lineTo(q, 18); x.stroke(); } }
      x.fillStyle = '#f56852'; x.font = '600 20px "IBM Plex Mono", Menlo, monospace'; x.textAlign = 'right';
      x.fillText((NRBTS.config.rulerText || 'NORTHERN RAISED · CM'), 1004, 140);
      var t = new THREE.CanvasTexture(c); t.encoding = THREE.sRGBEncoding; t.anisotropy = 4; return t;
    }
    function makeRuler() {
      var face = new THREE.MeshStandardMaterial({ map: rulerTexture(), roughness: 0.8, metalness: 0 });
      var g = new THREE.Group();
      g.add(new THREE.Mesh(new THREE.BoxGeometry(3.4, 0.54, 0.07), [mat.cream, mat.cream, mat.cream, mat.cream, face, face]));
      return shadowed(g);
    }
    function makeBook(w, h, d, cover) {
      var g = new THREE.Group();
      var pages = new THREE.Mesh(new THREE.BoxGeometry(w - 0.06, h - 0.06, d - 0.04), mat.page); pages.position.x = 0.04; g.add(pages);
      var top = new THREE.Mesh(new THREE.BoxGeometry(w, 0.035, d), cover); top.position.y = h / 2 - 0.0175; g.add(top);
      var bot = top.clone(); bot.position.y = -h / 2 + 0.0175; g.add(bot);
      var spine = new THREE.Mesh(new THREE.BoxGeometry(0.05, h, d), cover); spine.position.x = -w / 2 + 0.025; g.add(spine);
      return g;
    }
    function makeBooks() {
      var g = new THREE.Group();
      g.add(makeBook(1.7, 0.26, 1.25, mat.green));
      var b2 = makeBook(1.5, 0.2, 1.1, mat.coral); b2.position.y = 0.23; b2.rotation.y = 0.22; g.add(b2);
      var b3 = makeBook(1.3, 0.16, 0.95, mat.cream); b3.position.y = 0.41; b3.rotation.y = -0.12; g.add(b3);
      return shadowed(g);
    }
    function makeChalkSticks() {
      var g = new THREE.Group();
      for (var i = 0; i < 3; i++) {
        var m = new THREE.Mesh(new THREE.CylinderGeometry(0.075, 0.085, 0.95 - i * 0.12, 14), i === 1 ? mat.coral : mat.chalk);
        m.rotation.z = Math.PI / 2 + (i - 1) * 0.08;
        m.position.set(i * 0.12 - 0.12, i * 0.17 - 0.17, (i - 1) * 0.22);
        g.add(m);
      }
      return shadowed(g);
    }
    function makeEraser() {
      var g = new THREE.Group();
      g.add(new THREE.Mesh(new THREE.BoxGeometry(1.35, 0.3, 0.58), mat.felt));
      var handle = new THREE.Mesh(new THREE.BoxGeometry(1.35, 0.22, 0.58), mat.green); handle.position.y = 0.26; g.add(handle);
      return shadowed(g);
    }
    function makePlane() {
      var g = new THREE.Group();
      var geo = new THREE.BufferGeometry();
      var v = new Float32Array([1.3, 0, 0, -0.9, 0, 0, -0.95, 0.05, 0.75, 1.3, 0, 0, -0.95, 0.05, -0.75, -0.9, 0, 0, 1.3, 0, 0, -0.9, 0, 0, -0.6, -0.38, 0]);
      geo.setAttribute('position', new THREE.BufferAttribute(v, 3));
      geo.computeVertexNormals();
      g.add(new THREE.Mesh(geo, new THREE.MeshStandardMaterial({ color: lin(C_CREAM), roughness: 0.8, side: THREE.DoubleSide })));
      g.add(new THREE.LineSegments(new THREE.EdgesGeometry(geo, 1), new THREE.LineBasicMaterial({ color: lin(C_BOARD), transparent: true, opacity: 0.35 })));
      return shadowed(g);
    }
    function makeLunchBox() {
      var g = new THREE.Group(), W = 1.6, H = 0.95, D = 0.78, Tk = 0.06;
      [[W, Tk, D, 0, -H / 2 + Tk / 2, 0], [W, H, Tk, 0, 0, -D / 2 + Tk / 2], [W, H, Tk, 0, 0, D / 2 - Tk / 2], [Tk, H, D, -W / 2 + Tk / 2, 0, 0], [Tk, H, D, W / 2 - Tk / 2, 0, 0]].forEach(function (s) {
        var m = new THREE.Mesh(new THREE.BoxGeometry(s[0], s[1], s[2]), mat.green);
        m.position.set(s[3], s[4], s[5]); g.add(m);
      });
      var liner = new THREE.Mesh(new THREE.BoxGeometry(W - 2 * Tk - 0.01, H - Tk - 0.005, D - 2 * Tk - 0.01), new THREE.MeshStandardMaterial({ color: lin(0xf1e8d6), roughness: 0.9, metalness: 0, side: THREE.BackSide }));
      liner.position.y = Tk / 2; g.add(liner);
      var lid = new THREE.Group(); lid.position.set(0, H / 2, -D / 2);
      var panel = new THREE.Mesh(new THREE.BoxGeometry(W + 0.04, Tk, D + 0.04), mat.deep); panel.position.set(0, Tk / 2, D / 2); lid.add(panel);
      var handle = new THREE.Mesh(new THREE.TorusGeometry(0.27, 0.05, 10, 28, Math.PI), mat.coral); handle.position.set(0, Tk, D / 2); lid.add(handle);
      lid.rotation.x = -1.9; g.add(lid); g.lid = lid;
      var clasp = new THREE.Mesh(new THREE.BoxGeometry(0.24, 0.14, 0.04), mat.metal); clasp.position.set(0, H / 2 - 0.12, D / 2 + 0.02); g.add(clasp);
      var lc = document.createElement('canvas'); lc.width = 512; lc.height = 256;
      var x = lc.getContext('2d');
      x.fillStyle = '#faf6ef'; x.fillRect(0, 0, 512, 256);
      x.fillStyle = '#0a3c2c'; x.textAlign = 'center';
      x.font = '500 60px "Juana", "Fraunces", Georgia, serif';
      var l1 = NRBTS.config.boxLabel1 || 'Northern', l2 = NRBTS.config.boxLabel2 || 'Raised';
      x.fillText(l1, 256, 108); x.fillText(l2, 256, 178);
      x.fillStyle = '#f56852'; x.fillRect(70, 212, 372, 6);
      var lt = new THREE.CanvasTexture(lc); lt.encoding = THREE.sRGBEncoding;
      var label = new THREE.Mesh(new THREE.PlaneGeometry(0.98, 0.49), new THREE.MeshStandardMaterial({ map: lt, roughness: 0.85 }));
      label.position.set(0, -0.06, D / 2 + 0.006); g.add(label);
      return shadowed(g);
    }

    var defs = [
      { make: makePencil, d: { fx: .18, fy: .5, z: .4, s: 1, rot: [.25, 0, .7] }, m: { fx: -.66, fy: -.66, z: 0, s: .62, rot: [.2, 0, 1.2] }, amp: .18, spd: .7, ph: 0, spin: .12 },
      { make: makeApple, d: { fx: .5, fy: .06, z: 1.5, s: .95, rot: [.1, 0, 0] }, m: { fx: .52, fy: -.62, z: .6, s: .55, rot: [.1, 0, 0] }, amp: .16, spd: .6, ph: 1.2, spin: .25 },
      { make: makeRuler, d: { fx: .36, fy: -.6, z: -.5, s: 1, rot: [.2, 0, -.25] }, m: { fx: -.05, fy: -.86, z: -.4, s: .62, rot: [.15, 0, -.1] }, amp: .12, spd: .5, ph: 3.3, spin: .08 },
      { make: makeBooks, d: { fx: .78, fy: .64, z: -3, s: 1, rot: [.4, .5, .05] }, m: { fx: .76, fy: .86, z: -3.6, s: .75, rot: [.45, .5, .05] }, amp: .1, spd: .45, ph: .7, spin: .1 },
      { make: makeChalkSticks, d: { fx: .1, fy: -.95, z: 1, s: 1, rot: [.05, 0, 0] }, m: { fx: -.52, fy: -.93, z: 1, s: .65, rot: [.05, 0, 0] }, amp: .06, spd: .8, ph: 5, spin: .05 },
      { make: makePlane, d: { fx: .62, fy: .95, z: -.8, s: .8, rot: [.15, -.6, .2] }, m: { fx: -.68, fy: .9, z: -2.6, s: .6, rot: [.15, -.4, .2] }, amp: .2, spd: .5, ph: 2.6, spin: .2 },
      { make: makePencil, d: { fx: .95, fy: -.3, z: -1.8, s: .9, rot: [.1, .5, -1.05] }, m: null, amp: .14, spd: .55, ph: 2.1, spin: -.1 },
      { make: makeEraser, d: { fx: .04, fy: .76, z: -1.6, s: .85, rot: [.25, .25, .15] }, m: { fx: .35, fy: .92, z: -2.2, s: .55, rot: [.3, .2, .1] }, amp: .1, spd: .65, ph: 4.2, spin: .14, eraser: true }
    ];
    var BOX = { d: { fx: .88, fy: .06, z: .8, s: 1, rot: [.3, -.62, .03] }, m: { fx: .62, fy: -.76, z: -.4, s: .66, rot: [.32, -.5, .03] }, pd: { fx: .58, fy: -.1, z: 2.4, s: 1.8, rot: [.2, -.22, 0] }, pm: { fx: 0, fy: -.42, z: 1.8, s: 1.12, rot: [.22, -.16, 0] }, amp: .07, spd: .5, ph: 1.8 };
    var items = defs.map(function (d) {
      var o = d.make(); o.scale.setScalar(0.0001); scene.add(o);
      return { obj: o, def: d, cfg: d.d, base: { x: 0, y: 0, z: 0 }, off: false };
    });
    var box = { obj: makeLunchBox(), cfg: BOX.d, base: { x: 0, y: 0, z: 0 }, packed: { x: 0, y: 0, z: 0, s: 1, rot: [0, 0, 0] } };
    box.obj.scale.setScalar(0.0001); scene.add(box.obj);

    var mouse = { x: 0, y: 0, tx: 0, ty: 0 }, prog = 0, sm = 0, visible = true, raf = null, clock = new THREE.Clock(), mobile = mob0, erasePath = [], tmpV = new THREE.Vector3(), target = new THREE.Vector3(), lastVars = {};
    var wrapTop = 0, range = 1;
    function setVar(n, v) {
      v = v.toFixed(3);
      if (lastVars[n] !== v) { lastVars[n] = v; hero.style.setProperty(n, v); }
    }
    function measureWrap() {
      var r = heroWrap.getBoundingClientRect();
      wrapTop = r.top + window.scrollY;
      range = Math.max(1, heroWrap.offsetHeight - window.innerHeight);
    }
    function onScroll() { prog = reduce ? 0 : clamp01((window.scrollY - wrapTop) / range); request(); }
    function halfH(z) { return (camera.position.z - z) * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2)); }
    function halfW(z) { return halfH(z) * camera.aspect; }
    var inited = false;
    function layout() {
      var w = hero.clientWidth || 1, h = hero.clientHeight || 1;
      renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      mobile = w < 900 || w / h < 1.1;
      var hr = hero.getBoundingClientRect(), edge = 0;
      if (!mobile && copy) { var r = copy.getBoundingClientRect(); edge = Math.min(0.55, ((r.right - hr.left) / w) * 2 - 1); }
      var freeStart = mobile ? -1 : edge + 0.14;
      function fxOf(c) { return mobile ? c.fx : (freeStart + c.fx * (0.94 - freeStart)); }
      items.forEach(function (it) {
        var c = mobile ? it.def.m : it.def.d;
        if (!c) { it.obj.visible = false; it.off = true; return; }
        it.off = false; it.obj.visible = true; it.cfg = c;
        it.base = { x: fxOf(c) * halfW(c.z), y: c.fy * halfH(c.z), z: c.z };
      });
      var bc = mobile ? BOX.m : BOX.d, bp = mobile ? BOX.pm : BOX.pd;
      box.cfg = bc;
      box.base = { x: fxOf(bc) * halfW(bc.z), y: bc.fy * halfH(bc.z), z: bc.z };
      box.packed = { x: bp.fx * halfW(bp.z), y: bp.fy * halfH(bp.z), z: bp.z, s: bp.s, rot: bp.rot };
      var ez = 2.6; erasePath = [];
      each(hero.querySelectorAll('.nrb-hero-title .nrb-line'), function (l) {
        var inner = l.firstElementChild, lr = inner ? inner.getBoundingClientRect() : l.getBoundingClientRect();
        var y = -((((lr.top + lr.height * 0.55) - hr.top) / h) * 2 - 1) * halfH(ez);
        var x0 = (((lr.left - hr.left) / w) * 2 - 1) * halfW(ez);
        var x1 = (((lr.right - hr.left) / w) * 2 - 1) * halfW(ez);
        erasePath.push({ x: x0 - 0.5, y: y, z: ez }, { x: x1 + 0.4, y: y, z: ez });
      });
      measureWrap(); onScroll();
      if (!inited) { inited = true; sm = prog; }
      request();
    }
    function easeOutBack(x) { var c1 = 1.70158, c3 = c1 + 1; return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2); }
    function entrance(t, i) { return reduce ? 1 : clamp01((t - 0.3 - i * 0.09) / 0.9); }
    var afterOn = false, wiped = false;
    function frame() {
      raf = null;
      var dt = Math.min(0.1, clock.getDelta()), t = clock.getElapsedTime();
      sm += (prog - sm) * (1 - Math.pow(0.88, dt * 60));
      if (Math.abs(prog - sm) < 0.0005) sm = prog;
      var p = sm, live = reduce ? 0 : 1;
      mouse.x += (mouse.tx - mouse.x) * 0.05; mouse.y += (mouse.ty - mouse.y) * 0.05;
      var tb = smooth01((p - 0.66) / 0.26), tl = smooth01((p - 0.74) / 0.14), bf = 1 - tb, bc = box.cfg, bb = box.base, bp = box.packed;
      var fx = bb.x + live * bf * (Math.sin(t * BOX.spd + BOX.ph) * BOX.amp + mouse.x * 0.4);
      var fy = bb.y + live * bf * (Math.cos(t * BOX.spd * 0.8 + BOX.ph) * BOX.amp * 0.8 - mouse.y * 0.3);
      box.obj.position.set(lerp(fx, bp.x + live * mouse.x * 0.12, tb), lerp(fy, bp.y - live * mouse.y * 0.1, tb), lerp(bb.z, bp.z, tb));
      box.obj.rotation.set(
        lerp(bc.rot[0] + live * bf * Math.sin(t * 0.35 + 1.8) * 0.06, bp.rot[0], tb),
        lerp(bc.rot[1] + live * bf * Math.sin(t * 0.3) * 0.08, bp.rot[1] + live * mouse.x * 0.08, tb),
        lerp(bc.rot[2], bp.rot[2], tb));
      box.obj.scale.setScalar(Math.max(0.0001, lerp(bc.s, bp.s, tb) * easeOutBack(entrance(t, 2))));
      box.obj.lid.rotation.x = lerp(-1.9, 0, tl);
      target.set(box.obj.position.x, box.obj.position.y + 0.12 * box.obj.scale.x, box.obj.position.z + 0.1);
      items.forEach(function (it, i) {
        if (it.off) return;
        var o = it.obj, c = it.cfg, d = it.def, b = it.base, pf = Math.max(0.15, (c.z + 4) / 6);
        var s0 = d.eraser ? 0.36 : (0.2 + i * 0.045), tf = smooth01((p - s0) / 0.3), flf = 1 - tf;
        var x = b.x + live * flf * (Math.sin(t * d.spd + d.ph) * d.amp + mouse.x * 0.45 * pf);
        var y = b.y + live * flf * (Math.cos(t * d.spd * 0.8 + d.ph) * d.amp * 0.8 - mouse.y * 0.35 * pf);
        var z = b.z;
        var rx = c.rot[0] + live * flf * Math.sin(t * 0.35 + d.ph) * 0.12;
        var ry = c.rot[1] + live * flf * t * d.spin;
        var rz = c.rot[2] + live * flf * Math.cos(t * 0.4 + d.ph) * 0.08;
        if (d.eraser && erasePath.length === 4 && p > 0.02) {
          var u = smooth01((p - 0.02) / 0.26), pts = [{ x: x, y: y, z: z }].concat(erasePath), seg = Math.min(3, Math.floor(u * 4)), ltp = u * 4 - seg, a = pts[seg], bpt = pts[seg + 1];
          x = lerp(a.x, bpt.x, ltp);
          y = lerp(a.y, bpt.y, ltp) + Math.sin(ltp * Math.PI) * (seg === 0 ? 0.6 : 0.08);
          z = lerp(a.z, bpt.z, ltp);
          rx = 0.35; ry = lerp(c.rot[1], 0, u); rz = Math.sin(u * 30) * 0.06;
          if (u > 0.05 && u < 1 && !reduce && visible) {
            tmpV.set(x, y, z).project(camera);
            var cr = canvas.getBoundingClientRect();
            var sx = (tmpV.x + 1) / 2 * cr.width + cr.left, sy = (1 - tmpV.y) / 2 * cr.height + cr.top;
            Chalk.smear(sx, sy, 90);
            if (Math.random() < 0.3) Chalk.dust(sx, sy + 16, 1, 70);
          }
        }
        o.position.set(lerp(x, target.x, tf), lerp(y, target.y, tf) + Math.sin(tf * Math.PI) * 1.4, lerp(z, target.z, tf));
        o.rotation.set(rx + tf * 4.2, ry + tf * 2.5, rz + tf * 3.1);
        o.scale.setScalar(Math.max(0.0001, c.s * easeOutBack(entrance(t, i)) * (1 - tf * 0.94)));
        o.visible = tf < 0.995;
      });
      var wipe = smooth01((p - 0.03) / 0.25);
      setVar('--nrb-wipe', wipe);
      setVar('--nrb-cue', 1 - smooth01(p / 0.06));
      setVar('--nrb-after', smooth01((p - 0.84) / 0.12));
      if (wipe > 0.98 && !wiped) { wiped = true; hero.classList.add('nrb-wiped'); }
      else if (wipe < 0.98 && wiped) { wiped = false; hero.classList.remove('nrb-wiped'); }
      if (p > 0.84 && !afterOn) { afterOn = true; hero.classList.add('nrb-after-on'); if (afterEl) write(afterEl, 60); }
      else if (p < 0.7 && afterOn) { afterOn = false; hero.classList.remove('nrb-after-on'); if (afterEl) unwrite(afterEl); }
      renderer.render(scene, camera);
      if (!reduce && visible && !document.hidden) raf = requestAnimationFrame(frame);
    }
    function request() { if (!raf) raf = requestAnimationFrame(frame); }
    window.addEventListener('pointermove', function (e) {
      mouse.tx = (e.clientX / window.innerWidth - 0.5) * 2;
      mouse.ty = (e.clientY / window.innerHeight - 0.5) * 2;
    }, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measureWrap(); onScroll(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) request(); });
    if (io) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) request(); }, { threshold: 0 }).observe(hero);
    if ('ResizeObserver' in window) new ResizeObserver(function () { layout(); }).observe(hero);
    else window.addEventListener('resize', layout);
    if (started) setTimeout(layout, 120);
    else onReady.push(function () { setTimeout(layout, 60); });
    layout();
    } /* end boot3D */
  }

  /* ---------- init: run now and again when the theme editor reloads a section ---------- */
  function init() {
    ingest();
    ensureFilter();
    Chalk.ensure();
    scanWrite();
    observeRv();
    each(document.querySelectorAll('[data-nrb-products]'), initFilters);
    each(document.querySelectorAll('[data-nrb-marquee]'), initTicker);
    each(document.querySelectorAll('[data-nrb-slip]'), initSlip);
    each(document.querySelectorAll('[data-nrb-bell]'), initBell);
    each(document.querySelectorAll('[data-nrb-hero]'), initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });

  /* deep link: #qv-<handle> opens the quick view */
  function deepLink() {
    if (/^#qv-/.test(location.hash)) {
      var handle = location.hash.slice(4);
      var p = byHandle(handle);
      if (p) {
        QV.open(handle, { fromHistory: true });
        try { history.replaceState({ nrbQv: handle }, '', location.hash); } catch (e) { }
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', deepLink);
  else deepLink();
})();
